import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { naverLogin, linkLocal } from '../../lib/api/user-api';
import './LoginPage.css';

// 네이버 로그인 콜백(/sso/callback): code/state 를 받아 백엔드로 전달 → 토큰 저장 → 홈 이동
function SsoCallbackPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const oauthError = params.get('error');

    const savedState = sessionStorage.getItem('naver_oauth_state');
    sessionStorage.removeItem('naver_oauth_state');

    if (oauthError) {
      setError('네이버 로그인이 취소되었거나 실패했습니다.');
      return;
    }
    if (!code) {
      setError('잘못된 접근입니다. (인가 코드 없음)');
      return;
    }
    if (savedState && state && savedState !== state) {
      setError('보안 검증(state)에 실패했습니다. 다시 시도해주세요.');
      return;
    }

    (async () => {
      try {
        const response = await naverLogin(code, state || '');
        if (response?.success && response?.data?.token) {
          // 회원가입 화면에서 '네이버로 연동'을 눌러 넘어온 경우: 대기 중인 아이디/비밀번호를
          // 방금 로그인한(=소유 검증된) 계정에 연동한다. (이미 연동된 계정이면 조용히 무시)
          const pending = sessionStorage.getItem('pending_link');
          sessionStorage.removeItem('pending_link');
          let linkedMsg = '';
          if (pending) {
            try {
              const { userId, password } = JSON.parse(pending) || {};
              if (userId && password) {
                const linkRes = await linkLocal(response.data.token, userId, password);
                if (linkRes?.success) linkedMsg = '\n아이디/비밀번호 로그인이 연동되었습니다.';
              }
            } catch (linkErr) {
              // 이미 이메일 로그인이 설정된 계정 등 — 로그인은 성공했으므로 무시하고 진행
            }
          }
          login(response.data);
          if (linkedMsg) {
            try { window.alert(`네이버 로그인 성공${linkedMsg}`); } catch (e) { /* noop */ }
          }
          navigate('/home', { replace: true });
        } else {
          setError(response?.message || '네이버 로그인에 실패했습니다.');
        }
      } catch (e) {
        setError(e?.message || '네이버 로그인 처리 중 오류가 발생했습니다.');
      }
    })();
  }, [login, navigate]);

  return (
    <div className="login_page">
      <div className="login_container">
        <div className="login_header">
          <img src="/logo.png" alt="RANKER" className="login_logo" />
        </div>
        {!error ? (
          <p style={{ textAlign: 'center', color: '#555' }}>네이버 로그인 처리 중입니다...</p>
        ) : (
          <>
            <div className="login_error-message">{error}</div>
            <button
              type="button"
              className="login_button"
              onClick={() => navigate('/login', { replace: true })}
            >
              로그인으로 돌아가기
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default SsoCallbackPage;
